import dropUploadCodesOnSuccess from 'root/src/client/logic/tableItem/actions/dropUploadCodesOnSuccess'
import updateStepsCompleted from 'root/src/client/util/updateStepsCompleted'

export default body => async (dispatch, getState) => {
	dispatch(dropUploadCodesOnSuccess(body))
	updateStepsCompleted('hasKeysAndProducts', dispatch, getState)
}
